namespace application {

    $(() => {
        $('.application button[type=submit].application-submit').on('click', evt => {
            let button = jQuery(evt.target);
            let form = button.parents('form');
            if (form.is(':invalid')) {
                return;
            }
            button.prepend('<i class="fa fa-spinner fa-pulse" aria-hidden="true"></i> ');
            setTimeout(function () {
                button.attr('disabled', 'disabled');
            }, 100);
        });

        $('.js-response-btn').on('click', evt => {
            let button = jQuery(evt.currentTarget);
            $('#respond-feedback-modal #js-response-document-id').val(button.attr('data-document-id') || "");
            $('#respond-feedback-modal #js-doc-feedback-notes').val(button.attr('data-feedback-notes') || "");
            $('#respond-feedback-modal #js-doc-response-notes').val(button.attr('data-response-notes') || "");
            let hasFeedback = button.attr('data-has-feedback') || false;
            if (hasFeedback) {
                $('#respond-feedback-modal #js-doc-response-notes').removeAttr('disabled');
            }
            else {
                $('#respond-feedback-modal #js-doc-response-notes').attr('disabled', 'disabled');
            }

            let type = button.attr('data-document-type') || "";
            if (type) {
                $('#js-file-upload').show();
                $('#respond-feedback-modal #js-response-doc-type').html(type);
            }
            else {
                $('#js-file-upload').hide();
            }
        });

        $('.js-generate-download-title').each((_, element) => {
            var a = jQuery(element);
            let type = a.attr('data-type');
            let dateValue = a.attr('data-date');
            if (!dateValue) {
                return;
            }
            let date = new Date(dateValue);
            let title = `Download ${type} from ${date.toString()}`;
            a.attr('title', title);
        });

        $('.js-adm-contact-sel').on('change', evt => {
            let ddl = jQuery(evt.currentTarget);
            let val = ddl.val();
            let hasContact = !!val;
            $('.js-adm-require-contact').prop("disabled", !hasContact);
            if (!hasContact) {
                $('.js-adm-require-contact').prop("title", 'select a contact to enable');
            }
        }).trigger('change');

        $('.js-adm-contact-sel').on('change', evt => {
            let ddl = jQuery(evt.currentTarget);
            ddl.parents('form').submit();
        });

        // ignore dropping file outside of drop zone
        window.addEventListener("dragover", function (e) {
            e = e || event;
            e.preventDefault();
        }, false);
        window.addEventListener("drop", function (e) {
            e = e || event;
            e.preventDefault();
            //console.log('file dropped outside of dropzone, ignoring');
        }, false);

        $('.file-drop-box .custom-file-input').on('drop', evt => {
            $('.file-drop-box').removeClass('hover');
            evt.stopPropagation();
        });
        $('.file-drop-box .custom-file-input').on('dragover', evt => {
            evt.stopPropagation();
            evt.preventDefault();
            $('.file-drop-box').addClass('hover');
        });
        $('.file-drop-box  .custom-file-input').on('dragleave', evt => {
            evt.stopPropagation();
            evt.preventDefault();
            $('.file-drop-box').removeClass('hover');
        });

    });
}